module.exports = {
      id: "slider-right-arrow-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#slider-right-arrow",
      toString: function () {
        return this.url;
      }
    }